<template>
    <div class="special-content">
        <div class="title-bar">
            <h2 class="title">{{ special.title }}</h2>
            <div class="price-wrap">
                <span class="pre-price">{{ special.prePrice }}</span>
                <span class="price">{{ special.price }}</span>
                <span class="post-price">{{ special.postPrice }}</span>
            </div>
        </div>
        <ul>
            <li>Stock #: {{ special.stockNumber }}</li>
            <li v-if="special.line1.length">{{ special.line1 }}</li>
            <li v-if="special.line2.length">{{ special.line2 }}</li>
            <li v-if="special.line3.length">{{ special.line3 }}</li>
            <li v-if="special.line4.length">{{ special.line4 }}</li>
            <li v-if="special.useCustomDisclaimer && special.disclaimer.length">
                {{ special.disclaimer }}
            </li>
        </ul>
        <div class="buttons">
            <a :href="link" class="button" target="_blank" rel="noopener">
                Contact Us
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewSpecial',
    props: {
        baseUrl: {
            type: String,
            required: true,
        },
        special: {
            type: Object,
            required: true,
        },
    },
    computed: {
        type() {
            return this.$route.params.type;
        },
        link() {
            switch (this.special.arkona) {
                case 'CA1':
                    return 'https://www.auditucson.com/contact.htm';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.special-content {
    flex: auto;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 800px) {
        text-align: center;
    }
}
.title-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    line-height: 1;
    margin-bottom: 10px;
    @media screen and (max-width: 1000px) {
        display: block;
    }
}
.title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 10px;
    margin-top: 0;
    padding-right: 1rem;
}
.price-wrap {
    margin-bottom: 10px;
    white-space: nowrap;
}
.pre-price {
    font-size: 24px;
    padding-right: 5px;
}
.price {
    font-size: 26px;
    font-weight: 700;
    color: #479f28;
}
.post-price {
    font-size: 22px;
    padding-left: 5px;
}
ul {
    flex: auto;
    list-style-position: outside;
    margin: 0;
    margin-bottom: 20px;
    padding-left: 14px;
    list-style-type: square;
    line-height: 1.5;
    @media screen and (max-width: 800px) {
        list-style-type: none;
        padding: 0;
    }
}
.buttons {
    display: flex;
    .button {
        flex: auto;
        flex-basis: 0;
        margin-right: 10px;
        &:last-child {
            margin-right: 0;
        }
    }
    @media screen and (max-width: 480px) {
        flex-direction: column;
        .button {
            margin: 0;
            margin-bottom: 10px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
